<span
  class="list-label"
  *ngIf="formattedMsisdns && formattedMsisdns.length"
  translate>
  ASSIGNED_PHONE_NUMBERS
</span>
<div class="rows-wrapper" *ngIf="formattedMsisdns && formattedMsisdns.length">
  <div *ngFor="let item of formattedMsisdns" class="row">
    <cc-item-msisdn [msisdn]="item"></cc-item-msisdn>
  </div>
</div>
